<div *ngIf="!estaRedirigiendo" class="d-flex align-items-center justify-content-center vh-100 bg-light text-center">
  <div class="container">
    <h1 class="display-1 fw-bold text-danger">404</h1>
    <p class="fs-3 text-secondary">¡No funciona!</p>
    <p class="lead">La página que buscas no existe u ocurrió un error inesperado.</p>
    <!--<a routerLink="/" class="btn btn-primary btn-lg mt-3">
      Volver al inicio
    </a>-->
  </div>
</div>

<div *ngIf="estaRedirigiendo" style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; background-color: #f8f9fa;">
  <div style="width: 3.5rem; height: 3.5rem; border: 4px solid #ebe9f1; border-top: 4px solid #f3d30d; border-radius: 50%; animation: spinLoader 0.8s linear infinite;"></div>
  <style>
    @keyframes spinLoader {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  </style>
</div>

